// extracted by mini-css-extract-plugin
export default {"articles-header":"Articles_articles-header__m-pR1","title":"Articles_title__7HGrb","articles-list":"Articles_articles-list__02n2S"};